export default "__VITE_ASSET__BvjQV_vQ__"